import { EmailMessage } from '../types/EmailMessage';

const BASE = 'https://api.ephemail.space/emails'; // поменяешь на прод

export async function getEmails(address: string): Promise<EmailMessage[]> {
  const res = await fetch(`${BASE}?address=${encodeURIComponent(address)}`);
  return await res.json();
}

export async function deleteAllEmails(address: string) {
  await fetch(`${BASE}?address=${encodeURIComponent(address)}`, { method: 'DELETE' });
}

export async function deleteEmailById(id: string) {
  await fetch(`${BASE}/${id}`, { method: 'DELETE' });
}
